import styled from 'styled-components'
import Link from '../../utils/Link'

export const VyberHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Logo = styled.img`
  width: 100%;
  max-width: 130px;
`

export const LinkMore = styled(Link)`
  color: #f06600;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  border: none;
  padding: 9px;
  background: transparent;
  
  &:hover {
    color: #f06600;
    text-decoration: none;
  }
`

export const ArrowRight = styled.span`
  display: inline-block;
  border-right: 2px solid ${props => props.theme.vyber.arrow};
  border-bottom: 2px solid ${props => props.theme.vyber.arrow};
  width: 10px; height: 10px;
  transform: rotate(-45deg);
  position: relative;
  left: 5px;
  top: 0;
`
